import theme from '../variables';

const defaultTheme = {
  ...theme,
};

export default defaultTheme;
